import { PureComponent } from 'react';
import { Field } from 'redux-form';

import YearControl from '../Control';

export default class YearField extends PureComponent {
  render() {
    return <Field {...this.props} component={YearControl} />;
  }
}
